// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_owner.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { User } from "../../user/v1/user";
/**
 * The request message for listing app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnersRequest
 */
export interface ListAppEntitlementOwnersRequest {
    /**
     * The page_size field for pagination.
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * The app_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string entitlement_id = 4;
     */
    entitlementId: string;
}
/**
 * The response message for listing app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnersResponse
 */
export interface ListAppEntitlementOwnersResponse {
    /**
     * The list of owners for the app entitlement.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * The request message for listing app entitlement owner IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsRequest
 */
export interface ListAppEntitlementOwnerIDsRequest {
    /**
     * The page_size field for pagination.
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * The app_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to list owners of.
     *
     * @generated from protobuf field: string entitlement_id = 4;
     */
    entitlementId: string;
}
/**
 * The response message for listing app entitlement owners IDs.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsResponse
 */
export interface ListAppEntitlementOwnerIDsResponse {
    /**
     * The list of owner IDs for the app entitlement.
     *
     * @generated from protobuf field: repeated string user_ids = 1;
     */
    userIds: string[];
}
/**
 * The request message for adding an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.AddAppEntitlementOwnerRequest
 */
export interface AddAppEntitlementOwnerRequest {
    /**
     * The app_id field for the app entitlement to add the owner to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to add the owner to.
     *
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
    /**
     * The user_id field for the user to add as an owner of the app entitlement.
     *
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
}
/**
 * The empty response message for adding an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.AddAppEntitlementOwnerResponse
 */
export interface AddAppEntitlementOwnerResponse {
}
/**
 * The empty response message for setting the app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppEntitlementOwnersResponse
 */
export interface SetAppEntitlementOwnersResponse {
}
/**
 * The request message for setting the app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppEntitlementOwnersRequest
 */
export interface SetAppEntitlementOwnersRequest {
    /**
     * The app_id field for the app entitlement to set the owners of.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to set the owners of.
     *
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
    /**
     * The user_ids field for the users to set as an owner of the app entitlement.
     *
     * @generated from protobuf field: repeated string user_ids = 3;
     */
    userIds: string[];
}
/**
 * The request message for removing an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerRequest
 */
export interface RemoveAppEntitlementOwnerRequest {
    /**
     * The app_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
    /**
     * The user_id field for the user to remove as an owner of the app entitlement.
     *
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
}
/**
 * The empty response message for removing an app entitlement owner.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerResponse
 */
export interface RemoveAppEntitlementOwnerResponse {
}
/**
 * The request message for deleting app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersRequest
 */
export interface DeleteAppEntitlementOwnersRequest {
    /**
     * The app_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The entitlement_id field for the app entitlement to remove the owner of.
     *
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
}
/**
 * the empty response message for deleting app entitlement owners.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersResponse
 */
export interface DeleteAppEntitlementOwnersResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnersRequest$Type extends MessageType<ListAppEntitlementOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnersRequest
 */
export const ListAppEntitlementOwnersRequest = new ListAppEntitlementOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnersResponse$Type extends MessageType<ListAppEntitlementOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnersResponse
 */
export const ListAppEntitlementOwnersResponse = new ListAppEntitlementOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnerIDsRequest$Type extends MessageType<ListAppEntitlementOwnerIDsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnerIDsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsRequest
 */
export const ListAppEntitlementOwnerIDsRequest = new ListAppEntitlementOwnerIDsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementOwnerIDsResponse$Type extends MessageType<ListAppEntitlementOwnerIDsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementOwnerIDsResponse", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementOwnerIDsResponse
 */
export const ListAppEntitlementOwnerIDsResponse = new ListAppEntitlementOwnerIDsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppEntitlementOwnerRequest$Type extends MessageType<AddAppEntitlementOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.AddAppEntitlementOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppEntitlementOwnerRequest
 */
export const AddAppEntitlementOwnerRequest = new AddAppEntitlementOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAppEntitlementOwnerResponse$Type extends MessageType<AddAppEntitlementOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.AddAppEntitlementOwnerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAppEntitlementOwnerResponse
 */
export const AddAppEntitlementOwnerResponse = new AddAppEntitlementOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementOwnersResponse$Type extends MessageType<SetAppEntitlementOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppEntitlementOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppEntitlementOwnersResponse
 */
export const SetAppEntitlementOwnersResponse = new SetAppEntitlementOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppEntitlementOwnersRequest$Type extends MessageType<SetAppEntitlementOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppEntitlementOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App_Entitlement_Owner" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppEntitlementOwnersRequest
 */
export const SetAppEntitlementOwnersRequest = new SetAppEntitlementOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppEntitlementOwnerRequest$Type extends MessageType<RemoveAppEntitlementOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAppEntitlementOwnerRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerRequest
 */
export const RemoveAppEntitlementOwnerRequest = new RemoveAppEntitlementOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppEntitlementOwnerResponse$Type extends MessageType<RemoveAppEntitlementOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAppEntitlementOwnerResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAppEntitlementOwnerResponse
 */
export const RemoveAppEntitlementOwnerResponse = new RemoveAppEntitlementOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementOwnersRequest$Type extends MessageType<DeleteAppEntitlementOwnersRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementOwnersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersRequest
 */
export const DeleteAppEntitlementOwnersRequest = new DeleteAppEntitlementOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementOwnersResponse$Type extends MessageType<DeleteAppEntitlementOwnersResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementOwnersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementOwnersResponse
 */
export const DeleteAppEntitlementOwnersResponse = new DeleteAppEntitlementOwnersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementOwners
 */
export const AppEntitlementOwners = new ServiceType("c1.api.app.v1.AppEntitlementOwners", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppEntitlementOwners", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Entitlement Owner", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppEntitlementOwnersRequest, O: ListAppEntitlementOwnersResponse },
    { name: "ListOwnerIDs", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/ownerids", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App_Entitlement_Owner", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Entitlement Owner" }] } }, I: ListAppEntitlementOwnerIDsRequest, O: ListAppEntitlementOwnerIDsResponse },
    { name: "Add", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", group: "App Entitlement Owner" }] } }, I: AddAppEntitlementOwnerRequest, O: AddAppEntitlementOwnerResponse },
    { name: "Set", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App_Entitlement_Owner" }], group: "App Entitlement Owner" }] } }, I: SetAppEntitlementOwnersRequest, O: SetAppEntitlementOwnersResponse },
    { name: "Remove", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners/{user_id}", group: "App Entitlement Owner" }] } }, I: RemoveAppEntitlementOwnerRequest, O: RemoveAppEntitlementOwnerResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{entitlement_id}/owners", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App_Entitlement_Owner" }], group: "App Entitlement Owner" }] } }, I: DeleteAppEntitlementOwnersRequest, O: DeleteAppEntitlementOwnersResponse }
]);
